import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

import React, { useEffect, useMemo, useRef, useState } from 'react';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Trans, useTranslation } from 'react-i18next';
import { Dialog } from 'primereact/dialog';
import { Checkbox } from 'primereact/checkbox';

import AuthenticationService from '../service/AuthenticationService';
import EventBus from "../common/EventBus";
import CompanyService from '../service/CompanyService';
//import { useHistory } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import utils from '../constants/utils';
import AccountService from '../service/AccountService';
import AuthService from '../security/AuthService';
import PasswordChecklist from "react-password-checklist"
import Constants from '../constants/Constants';

import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import FileService from '../service/FileService';
import CustomAddArtworks from './CustomAddArtworks';

const CustomAddPanel = (props) => {
    console.log("CustomAddPanel  ",props);

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const [selectedAddType, setSelectedAddType] = useState();



    console.log("CustomAddPanel props: ", props);


    useEffect(() => {

    }, []);

   
    const renderAddType = () => {
        return (
            <div className="flex flex-column align-items-center justify-content-between register-content p-3" style={{minWidth:250}}>
                <div className="col-12 md:col-12 w-12 text-400" >
                    {t('add_artwork_descr1')}
                </div>

                <div className="grid w-fit flex justify-content-center  ">

                    {Constants.addTypes.map((addType, index) => {
                        //
                        return (

                            <div className="card_member  text-xs flex flex-column flex align-items-center justify-content-center m-2 user-type-box"
                                onClick={() => { setSelectedAddType(addType.type) }}
                                style={{
                                    backgroundColor: selectedAddType === addType.type ? 'black' : 'white',
                                    color: selectedAddType === addType.type ? 'white' : 'black',

                                }}
                            >
                                <img src={selectedAddType === addType.type ? addType.icon_active : addType.icon} style={{ paddingBottom: 3 }} width={35}
                                    alt={addType.type}
                                ></img>
                                <span className="pi pi-artwork"></span>
                                {t(addType.descr)}
                            </div>
                        )
                    })
                    }


                </div>
            </div>

        )

    }


    const renderAddPanel = () => {
        console.log();

        {
            if (selectedAddType === 'artwork') {
                return (
                    <CustomAddArtworks {...props}
                     ></CustomAddArtworks>
                )
            }
            else  if (selectedAddType === 'exhibits') {
                navigate("/exhibition/edit/" + AuthService.getUserId() );
            }
        }


    }


    const chooseOptions = { icon: 'fas fa-cloud-arrow-up file-upload-icon p-button-header', iconOnly: true, padding: 0 };

    return (
        <div className="grid p-fluid flex justify-content-center p-2" style={{ maxWidth: 650 }}>
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>

            {renderAddType()}
            {renderAddPanel()}



        </div>
    )
}

export default CustomAddPanel;